// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__2obAZ","btnRed":"styles_btnRed__29rAQ","noTender":"styles_noTender__2SAJY","title":"styles_title__3zZ7s"};